<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button :class="{ 'md-primary': enableApproveButton }" :disabled="!enableApproveButton" @click="approve()">
				{{ $t("investorSellerDebtorConfig.button.approve") }}
			</md-button>
		</div>
		<div class="operation_item">
			<md-button :class="{ 'md-block': enableRejectButton }" :disabled="!enableRejectButton" @click="reject()">
				{{ $t("investorSellerDebtorConfig.button.reject") }}
			</md-button>
		</div>
	</div>
</template>
<script>
import {enumDef} from "@/common/enumDefs";

export default {
	methods: {
		approve() {
			this.params.approve(this.params.node);
		},
		reject() {
			this.params.reject(this.params.node);
		}
	},
	computed: {
		enableApproveButton() {
			return this.params.data.status !== enumDef.InvestorSellerDebtorConfigStatus.Approved;
		},
		enableRejectButton() {
			return this.params.data.status !== enumDef.InvestorSellerDebtorConfigStatus.Rejected;
		}
	}

}
</script>